import React from 'react'
import { LiabilityTotals } from './LiabilityTotals'
import { LiabilityTabs } from './LiabilityTabs'

export const Index = () => {
  return (
    <>
      <LiabilityTotals />
      <LiabilityTabs />
    </>
  )
}
